var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.childDataLoaded)?_c('div',[_c('applicant-form',{attrs:{"userData":_vm.userData,"states":_vm.states,"employment_status":_vm.employment_status,"isJobIdValid":_vm.isJobIdValid,"isForEditData":_vm.isForEditData,"postUserData":_vm.postUserData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }